export default "__VITE_ASSET__DFllXlxb__"